<script>
import BasicButton from "../atoms/BasicButton.vue";

export default {
  name: "BasicForm",
  props: {
    action: {
      type: String,
      required: false,
      default() {
        return ''
      }
    },
    method: {
      type: String,
      default() {
        return 'POST'
      }
    },
    enctype: {
      type: String,
      default() {
        return 'multipart/form-data'
      }
    },
    submitText: {
      type: String,
      default() {
        return trans('general.defaults.submit')
      }
    },
    submitClass: {
      type: String,
      default() {
        return 'btn-submit btn-primary'
      }
    },
    submitIcon: {
      type: String,
      default() {
        return ''
      }
    },
    useDefaultSubmit: {
      type: Boolean,
      default() {
        return true
      }
    },
    isSubmitting: {
      type: Boolean,
      default: false
    },
    acceptTerms: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BasicButton
  },
  data() {
    return {
      submitting: false,
      terms: false,
    }
  },
  watch: {
    isSubmitting: {
      handler: function (val) {
        this.submitting = val
      },
    },
    submitting: function (val) {
      this.$emit('submitStatusChange', val);
    },
  },
  methods: {
    submit() {
      if (this.useDefaultSubmit) {
        this.submitting = true;
        axios({
          method: this.method,
          url: this.action,
          data: new FormData(this.$el),
          headers: {"Content-Type": this.enctype},
        }).then(response => {
          this.$emit('success', response);
          this.submitting = false;
        }).catch(error => {
          this.submitting = false;
          if (error.response.data.errors) {
            this.$emit('validations', error.response.data.errors)
          }
          if (error.response.data.message) {
            this.$emit('error', error.response.data.message)
            this.$notify({type: 'error', text: error.response.data.message});
          }
        });
      } else {
        this.$emit('submit', this.$el)
      }
    },
    reset() {
      this.$el.reset();
    },
    getLandingUrl() {
      return appConfig.landingUrl + '/en';
    }
  }
}

</script>

<template>
  <form :action="action" :method="method" ref="from" :enctype="enctype" @submit.prevent="submit">
    <slot name="header"></slot>
    <slot></slot>
    <slot name="footer" v-bind:submitting="submitting">
      <div class="d-flex gap-3 flex-column flex-lg-row justify-content-end align-items-center">
        <slot name="actions" class="flex-grow-1"></slot>
        <slot name="submitButton" class="flex-grow-0" v-bind:submitting="submitting">
          <!--TODO: The form check should be removed from here and placed on concrete implementation-->
          <div class="form-check" v-if="acceptTerms">
            <input v-model="terms" class="form-check-input" type="checkbox" id="flexCheckChecked">
            <label class="form-check-label" for="flexCheckChecked" v-html="trans('general.defaults.accept_privacy_and_terms', {
                    privacy: `<a target='_blank' href='${getLandingUrl()}/privacy-policy'>${trans('general.defaults.privacy_policy')}</a>`,
                    terms: `<a target='_blank' href='${getLandingUrl()}/terms-and-conditions'>${trans('general.defaults.terms_and_conditions')}</a>`
                })"/>
          </div>

          <basic-button :text="submitText" :loading="submitting" :cls="submitClass" :disabled="acceptTerms && !terms"
                        type="submit" icon-position="right" :icon="submitIcon"/>
        </slot>
      </div>
    </slot>
  </form>
</template>
